<div class="notice-main-container" [ngClass]="[size, type, fill]">
  <div class="icon-container" [ngClass]="[size]">
    <mat-icon *ngIf="!!icon" class="material-symbols-outlined">{{ icon }}</mat-icon>
  </div>
  <div class="notice-container" [ngClass]="[size, type]">
    <div class="notice-header-container">
      <h4 class="notice-header">{{ title }}</h4>
    </div>
    <p>{{ body }}</p>
    <ng-content></ng-content>
  </div>
</div>
